import { useEffect } from 'react';

const META_NAME = 'robots';
const META_CONTENT = 'noindex, nofollow';
const META_ATTR = 'data-managed-by';
const META_ATTR_VALUE = 'NoIndex';

const NoIndex = () => {
  useEffect(() => {
    let metaTag = document.head.querySelector(`meta[name="${META_NAME}"]`);
    const createdByComponent = !metaTag;
    const previousContent = metaTag?.getAttribute('content') || null;
    const previousManager = metaTag?.getAttribute(META_ATTR) || null;

    if (!metaTag) {
      metaTag = document.createElement('meta');
      metaTag.setAttribute('name', META_NAME);
      document.head.appendChild(metaTag);
    }

    metaTag.setAttribute('content', META_CONTENT);
    metaTag.setAttribute(META_ATTR, META_ATTR_VALUE);

    return () => {
      if (!metaTag) return;

      if (createdByComponent) {
        metaTag.remove();
        return;
      }

      if (previousContent) {
        metaTag.setAttribute('content', previousContent);
      } else {
        metaTag.removeAttribute('content');
      }

      if (previousManager) {
        metaTag.setAttribute(META_ATTR, previousManager);
      } else {
        metaTag.removeAttribute(META_ATTR);
      }
    };
  }, []);

  return null;
};

export default NoIndex;
